import styled from 'styled-components'

export default styled.div`
  padding-left: 9%;
  padding-right: 9%;
  padding-top: 0.75em;
  position: relative;
  transition: padding-left, padding-right, 0.2s ease-out;
  width: 100%;

  @media (max-width: 1023px) {
    padding-left: 4%;
    padding-right: 4%;
  }

  .main {
    min-height: 100%;
  }

  .top {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 1.68em 0 2em;
    width: 100%;

    .menu {
      display: flex;
      flex-direction: column;
      position: relative;
      text-align: right;
      top: 0;
      transition: top 0.3s ease-out;
    }
  }

  .paragraph {
    max-width: 530px;
    padding-bottom: ${({ theme: { paragraphPaddingBottomEm } }) => paragraphPaddingBottomEm};

    @media (max-width: 1357px) {
      max-width: 500px;
    }
    @media (max-width: 1250px) {
      max-width: 460px;
    }
    @media (max-width: 1115px) {
      max-width: 400px;
    }
  }

  .hint {
    color: #aba8a1;
    font-size: 1em;
    margin: 0;
    padding-bottom: calc(3em + 50px);
    padding-top: 0.3em;
  }

  .hint span {
    font-size: 1rem;
    position: relative;
    top: 0.125em;
  }
`

export const Link = styled.a`
  align-self: flex-end;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: rgba(12, 79, 114, 0.2);
  color: #125071;
  display: inline-block;
  font-size: 0.93em;
  padding: 0.3em 0 0;
  text-decoration: none;

  &:hover {
    color: #fe5353;
    border-color: #f6c9cb;
  }
`

export const LinkButton = Link.withComponent('button').extend`
  background-color: #fff;
  border-color: rgba(12, 79, 114, 0.2);
  border-radius: 8px;
  border-width: 1px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1.35;
  padding: 0.125em 1em 0.25em;
`

export const Main = styled.div`
  margin-bottom: -50px;
  min-height: 100%;
`

export const Title = styled.input`
  font-size: 2.25em;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  padding: 0;
  border: none;
  width: 70%;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const Footer = styled.p`
  height: 50px;
  margin: 0;
  padding-left: 9%;
  transition: padding-left 0.2s ease-out;

  @media (max-width: 1023px) {
    padding-left: 4%;
  }
`



// WEBPACK FOOTER //
// ./src/components/RemarksApplicationRoot/Styles.ts